import { render, staticRenderFns } from "./OfficialHolidaysPlanDetails.vue?vue&type=template&id=6480f1be&"
import script from "./OfficialHolidaysPlanDetails.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports